import axios from "@/plugins/axios";

let url = "/api/v1/accounts";

export const account = {
    get(){
        return axios.get(`${url}`).then(result => result.data);
    },
    survey: {
        post(data){
            return axios.post(`${url}/survey`, data).then(result => result.data);
        }
    },
    certify: {
        post(data){
            return axios.post(`${url}/certify`, data).then(result => result.data);
        }
    },
    verify: {
        put(data){
            return axios.put(`${url}/verify`, data).then(result => result.data);
        }
    },
    skip: {
        post(data){
            return axios.post(`${url}/skip`, data).then(result => result.data);
        }
    }
}